<template>
    <div class="vertical icon-button" style="justify-content: center; align-items: center;" @click="onClick">
        <div class="horizontal">
            <slot></slot>
            <span class="icon-text">{{text}}</span>
        </div>
        <div class="selected"></div>
    </div>
</template>

<script>
export default { 
  props: ['icon', 'text'],
  data() {
    return {
    };
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    }
  },
  mounted(){
  }
}
</script>

<style scoped>
.icon-text {
  margin-top: 5px;
}
</style>

<style>
.main-submenu-bar .icon-button {
    margin-bottom: 4px;
}

.main-submenu-bar li.router-link-exact-active .icon-button{
    margin-bottom: 0px;
}

.main-menu-bar li.router-link-exact-active .selected{
    border-bottom: 4px solid white !important;
    margin-bottom: 0px;
    border-radius: 15px;
    width: 120%;
}
</style>


// WEBPACK FOOTER //
// src/components/RouterLinkIconHorizontal.vue